import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { map, of } from 'rxjs';
import { LogistikProductOrdering } from '../LogistikProductOrdering.js';

const subscribeLogistikProductOrderingByProductCategory = registerSubscription({
  operationName: 'subscribeLogistikProductOrderingByProductCategory',
  type: () => LogistikProductOrdering,
  params: [{ name: 'category', type: () => String }],
  resolve:
    (category: string) =>
    <SelSet extends BaseQLSelectionSet<LogistikProductOrdering>>(gqlFields: SelSet) =>
      category
        ? watchQuery(LogistikProductOrdering._collectionName, { productCategory: category }).pipe(
            map(a => (a ? (a[0] as LogistikProductOrdering) : undefined)),
          )
        : of(undefined),
});

export namespace LogistikProductOrderingAPI {
  export const subscribeByCategory = subscribeLogistikProductOrderingByProductCategory;
}
